const page2info = {
    subIndex: {
        key: 'subIndex',
        ele: document.querySelector('.section-2 .sub-index'),
    },
    sub1: {
        key: 'sub1',
        ele: document.querySelector('.section-2 .sub-1'),
    },
    sub2: {
        key: 'sub2',
        ele: document.querySelector('.section-2 .sub-2'),
    },
    sub3: {
        key: 'sub3',
        ele: document.querySelector('.section-2 .sub-3'),
    }
};

const page3info = {
    sub1: {
        key: 'sub1',
        ele: document.querySelector('.section-3 .sub-1'),
    },
    sub2: {
        key: 'sub2',
        ele: document.querySelector('.section-3 .sub-2'),
    },
    sub3: {
        key: 'sub3',
        ele: document.querySelector('.section-3 .sub-3'),
    },
    sub4: {
        key: 'sub4',
        ele: document.querySelector('.section-3 .sub-4'),
    }
};

export { page2info, page3info };



// WEBPACK FOOTER //
// ./src/js/subDeath/subpageInfo.js